import { render, staticRenderFns } from "./GeneralDiscountNewForm.vue?vue&type=template&id=74f8c79f"
import script from "./GeneralDiscountNewForm.vue?vue&type=script&lang=js"
export * from "./GeneralDiscountNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports